import {createBrowserRouter, redirect} from "react-router-dom";
import Layout from "components/Layout";
import Login from "components/Login/Login";
import Profile from "components/Profile/Profile";
import Project from "../components/Project/Project";
import Settings from "../components/Settings/Settings";
import ErrorBoundary from "../components/ErrorBoundary";


async function loginLoader() {
    const storedUser = localStorage.getItem('user');
    if (storedUser == undefined || storedUser == null) {
        return redirect('/login')
    }
    return JSON.parse(storedUser);
}


const routes = createBrowserRouter([
    {
        path: '/login',
        element: <Login/>
    },
    {
        id: 'root',
        path: '/',
        loader: loginLoader,
        element: <Layout/>,
        children: [
            {
                index: true,
                path: '',
                element: <Project/>
            },
            {
                path: '/profile',
                element: <Profile/>
            },
            {
                path: '/settings',
                element: <Settings/>
            },
        ]
    },
    {
        path: '*',
        element: <ErrorBoundary/>,
    },
])

export default routes;